import {FaAddressCard, FaEye} from "react-icons/fa";
import {FaPencil} from "react-icons/fa6";
import {getUrl} from "../../../constants/urls";

export const ACTIONS_LIST = [
  {label: "Edit", icon: FaPencil, perms: ["change_customer"]},
  {label: "View_Custom_Fields", icon: FaEye, perms: []},
  {
    label: "Contacts",
    icon: FaAddressCard,
    perms: ["view_customercontactperson"],
  },
];

export const LIST_HEADERS = ["id", "name", "contact_person", "select"];

export const customerListURL = getUrl("getCustomers");

export const PERMS_FOR_ACTIONS = ["change_customer", "view_customercontactperson"];
